<template>
  <div class="widget-info box flex column text-truncate animated fadeInRight" v-show="!isLoading">
    <el-divider></el-divider>
    <div class="flex">
      <div class="box grow flex column">
        <div class="box grow body1 pre-wrap capitalize-first-letter">{{ title }}</div>
        <div class="box subtitle2">Past 24 hours</div>
      </div>
      <div v-if="hasWindowsLinux" class="box body1 justify-right">
        <span class="cursor-pointer" @click.stop="userClick(insightsType[0])"
        >Windows: {{ kpiChartInsights[0] }} <br
        /></span>
        <span class="cursor-pointer" @click.stop="userClick(insightsType[1])">Linux: {{ kpiChartInsights[1] }}</span>
      </div>
      <div v-else class="box body1 justify-right" @click.stop="userClick(insightsType)">
        {{ renderKpiChartInsights }}
      </div>
    </div>
  </div>
</template>
<script>
import {DASHBOARD_INSIGHTS_REQ} from '@/store/modules/dashboard/kpi-statistics.type'

export default {
  name: 'InsightsInfoCard',
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    kpiType: {
      type: [String, Array],
      default: () => {
        return ''
      }
    },
    insightsType: {
      type: [String, Array],
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      isLoading: true,
      hasWindowsLinux: false,
      kpiChartInsights: []
    }
  },
  mounted() {
    if (_.isArray(this.kpiType)) {
      Promise.all([
        this.$store.dispatch(DASHBOARD_INSIGHTS_REQ, {
          kpiType: this.kpiType[0],
          insightsType: this.insightsType[0]
        }),
        this.$store.dispatch(DASHBOARD_INSIGHTS_REQ, {
          kpiType: this.kpiType[1],
          insightsType: this.insightsType[1]
        })
      ]).then(responses => {
        this.hasWindowsLinux = true
        this.kpiChartInsights = responses
        this.isLoading = false
      })
    } else {
      this.$store
          .dispatch(DASHBOARD_INSIGHTS_REQ, {
            kpiType: this.kpiType,
            insightsType: this.insightsType
          })
          .then(apiResponses => {
            this.kpiChartInsights = [apiResponses]
            this.isLoading = false
          })
    }
  },
  methods: {
    userClick(kpi) {
      this.$emit('insights-click', kpi, this.kpiChartInsights)
    }
  },
  computed: {
    renderKpiChartInsights() {
      switch (this.insightsType) {
        case 'dlls_creating_procs':
        case 'execs_creating_procs':
          return this.kpiChartInsights[0] ? this.kpiChartInsights[0].length : ''
        default:
          return this.kpiChartInsights[0]
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  margin-top: 0px;
  margin-bottom: 5px;
}

span {
  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

.pre-wrap {
  width: 90%;
  white-space: pre-wrap;
  word-break: break-word;
}

.justify-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/InsightsInfoCard.vue